<div>
  <h2 i18n>We'd love to hear your thoughts on this idea</h2>
  <p i18n>
    Now that you have had a look, we would like to hear what you think. Your feedback is greatly appreciated, and will
    help us improve our work to develop valuable solutions for you. Thank you!
  </p>
  <p class="sub-text">{{ subtitle() }}</p>
  <div class="rating">
    @for (rating of ratings; track rating) {
      <div class="element" (click)="openModal(rating.rating)" (keypress)="openModal(rating.rating)" tabindex="0">
        <app-rating-icon [rating]="rating.rating" />
        <div>{{ rating.label }}</div>
      </div>
    }
  </div>
</div>
